import React from 'react';
import { SubHeading } from '../../components';
import { images,data } from '../../constants';
import './Laurels.css';

const Laurels = () => (
  <div className='app__bg section__padding app__wrapper' id='awards'>
    <div className='app__wrapper-logo'>
    <img src={images.logo} alt="logo" />
    </div>
    <div className="app__wrapper_info" style={{flex:'1'}}>
      <SubHeading  title='Awards & recognition'/>
      <h1 className="headtext__cormorant">Our Laurels</h1>
    
      <div className="app__laurels_awards">
        {
          data.awards.map(({imgUrl,subtitle,title}) => (
            <div className='app__laurels_awards-cards' key={title}>
              <img src={imgUrl} alt="award" />
              <div  className='app__laurels_awards-cards_content'>
                <h1 style={{color:'#DCCA87'}}>{title}</h1>
                <p>{subtitle}</p>
              </div>
            </div>
          ))
      }
      </div>
    
    </div>

    <div className="app__wrapper_img">
      <img src={images.laurels} alt='laurels' style={{width:'100%'}} />
    </div>
  </div>
);

export default Laurels;
